<template>
  <loading :active.sync="active" :can-cancel="false" :is-full-page="false" />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

@Component({
  components: {
    Loading
  }
})
export default class BBSectionLoader extends Vue {
  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  isLoading

  get active() {
    return this.isLoading
  }
}
</script>
